import { Grid, Typography, Box, useTheme, Stack } from "@mui/material"
import {Facebook,YouTube, Instagram, LinkedIn} from '@mui/icons-material';
import { useRouter } from "next/router";
import Link from 'next/link';
import { useSelector } from "react-redux";
import { customComponentTypes } from "../../customComponents/types";
import Image from "next/image";
import EkhoolImage from "../ekhoolImage/ekhoolImage";

const key = 'footer3'

const Footer3 = () => {

    const theme = useTheme();
    
    const PRIMARY_MAIN = theme.palette.primary.main;
    const PRIMARY_DARK = theme.palette.primary.dark;

    const router = useRouter()
    const { reducer } = useSelector((state) => state);
    const { themeBuilderJson, appData } = reducer;

    const themeJson = themeBuilderJson?.components?.filter((i) => (i.key === key));
    const themeItem = themeJson?.length > 0 && themeJson[0];
    const style = themeItem && themeItem.style;

    const children = themeItem?.children;
    const content  = themeItem?.content;


    const footerDetails = [
        {
            name:'About Us',
            route:'/about-us'
        },
        {
            name:'Become A Tutor',
            route:'/tutor'
        },
        {
            name:'Contact Us',
            route:'/contact-us'
        },            
    ]

    const footerPolicy = [
        {
            name:'Privacy Policy',
            route: '/privacy'
        },
        {
            name:'Terms of Use',
            route: '/terms'
        },
        {
            name:'Cookie Policy',
            route: '/cookie'
        },
        {
            name:'Cancellation policy',
            route:'/cancellation-policy'
        }, 
    ]

    const footerLanguage = [
        {
            name:'German',
            route:'/german'
        },
        {
            name:'French',
            route:'/french'
        },
        {
            name:'Spanish',
            route:'/spanish'
        },
        {
            name:'IELTS',
            route:'/ielts'
        },
    ]

    const icons = [
        { 
            icon:
                <Link href="https://www.facebook.com/CommCult" > 
                    <Facebook/>
                </Link>                 
        },
        {           
            icon:
                <Link href="https://www.youtube.com/channel/UCERapE9G9Ynn41ZcyuGL1Hw" >
                    <YouTube/>
                </Link>
        },
        {            
            icon:
                <Link href="https://www.instagram.com/accounts/login/" >
                    <Instagram/>
                </Link>
        },
        {           
            icon:
                <Link href="https://www.linkedin.com/" >
                    <LinkedIn/>
                </Link>
        },
    ]


    return(
        
        <Box
            minHeight={500}
            display={'flex'}
            justifyContent="center"
            flexDirection={'column'}
            sx={{
                backgroundColor: '#C2D1BA',
                color: '#000'
            }}
        >
            
            <Grid container
                px={2}
        
                spacing={{ xs: 1, md: 2, md:3, xl:3 }} 
                columns={{xs:0, sm:7, md:12, l:14, xl:15 }} 
                alignItems={'center'}
                display={'flex'}
                justifyContent="center"
                gap={7}
               
            >   

                <Box height={60} width={200} position={'relative'} >

                {/* {
                    children?.filter((i) => (i.type === customComponentTypes.image))?.slice(0, 1)?.map((item, index) => {
                        return (
                            <Image src={item?.image_url} layout={'fill'} />
                        )
                    })
                } */}

                    {
                        appData &&
                        <EkhoolImage src={appData?.logo} layout={'fill'} objectFit={'contain'} />
                    }

                </Box>

                <Box display={'flex'} flexDirection={'column'} gap={5} alignItems={'center'} justifyContent={'center'} >

                    <Box 
                        maxWidth={500} 
                        minWidth={{
                            xl: 500,
                        }} 
                        px={{
                            xs: 5
                        }}
                    >

                        {/* <Typography variant={'h4'} dangerouslySetInnerHTML={{ __html: content?.title }} /> */}
                        {/* <Typography dangerouslySetInnerHTML={{ __html: content?.content }} /> */}

                        <Typography>As quoted by the legendary English artist, Edmund De Waal, we believe that "With languages, you are at home, anywhere".</Typography>

                        <Box display={'flex'} flexDirection={'row'} mt={2} >

                                {
                                    icons.map((item, index) => {
                                        return(
                                            
                                            <Grid item 
                                                sx={{
                                                    cursor:'pointer',
                                                    height: 35,
                                                    width: 35,
                                                    backgroundColor: 'primary.main',
                                                    mx: 0.5,
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    color: '#fff' ,
                                                    '&:hover':{
                                                        color:'gray'
                                                    }            
                                                }}
                                            >{item.icon}</Grid>
                                        )
                                    })
                                }

                            </Box>

                        {/* <Typography variant={'h4'} >Commcult</Typography>
                        <Typography >As quoted by the legendary English artist, Edmund De Waal, we believe that "With languages, you are at home, anywhere".</Typography> */}

                    </Box>

                </Box>

                <Stack
                    direction={{ xs: 'column', sm: 'column', md:'row', lg:'row', xl:'row' }}
                    gap={4}
                >
                    <Box>
                        {
                            footerDetails.map((item, index) => {
                                return(
                                    <Typography
                                        onClick={() => {router.push(`${item.route}`)}}
                                        sx={{
                                            cursor:'pointer', 
                                        }}
                                    >{item.name}</Typography>
                                )
                            })
                        }
                    </Box>

                    <Box>
                        {
                            footerPolicy.map((item, index) => {
                                return(
                                    <Typography
                                        onClick={() => {router.push(`${item.route}`)}}
                                        sx={{
                                            cursor:'pointer', 
                                        }}
                                    >{item.name}</Typography>
                                )
                            })
                        }
                    </Box>

                    <Box>
                        {
                            footerLanguage.map((item, index) =>
                            {
                                return(
                                    <Typography
                                        onClick={() => {router.push(`/category/${item.route}`)}}
                                        sx={{
                                            cursor:'pointer', 
                                        }}
                                    >{item.name}</Typography>
                                )
                            })
                        }
                    </Box>
                </Stack>

            </Grid>

        </Box>


        
        
    )
}
export default Footer3;